import { XIcon } from '@heroicons/react/outline'
import { useRef, useState } from 'react'
import { CartAPI } from '../../apis/CartAPI'
import { applyCouponCart } from '../../helpers/checkout'
import { getErrorMessage } from '../../helpers/utils'
import ErrorAlert from '../Alerts/ErrorAlert'
import InlineLoader from '../InlineLoader'
import Loader from '../Loader'

const CouponForm = ({ counponText, applyCoupon }) => {
    const handleSubmit = (e) => {
        e.preventDefault()
        applyCoupon()
    }

    return (
        <form
            id="coupon-form"
            name="coupon-form"
            onSubmit={handleSubmit}
            className="flex items-center justify-between w-full gap-2">
            <input
                type="text"
                ref={counponText}
                className="block w-full focus:ring-olh focus:border-olh py-2 px-3 sm:text-sm text-gray-800 border border-gray-200 rounded-lg"
                placeholder="Discount Code"
            />
            <button
                type="submit"
                form="coupon-form"
                className="bg-olm text-white font-semibold relative flex items-center rounded-lg p-2 text-center cursor-pointer hover:bg-olh focus:outline-none sm:text-sm"
                aria-haspopup="listbox"
                aria-expanded="true"
                aria-labelledby="listbox-label">
                <span className="mx-2">Apply</span>
            </button>
        </form>
    )
}

function Coupon({ cart, afterCouponApply }) {
    const coupons = Array.isArray(cart?.coupons) ? cart.coupons : []
    const [loader, setLoader] = useState(false)

    const counponText = useRef('')
    const [error, setError] = useState('')

    const removeCoupon = async (coupon) => {
        try {
            setLoader(true)
            await CartAPI.removeCoupon(coupon)
            await afterCouponApply()
        } catch (e) {
            console.log(e)
        } finally {
            setLoader(false)
        }
    }

    const applyCoupon = async () => {
        setError('')
        setLoader(true)
        let code = String(counponText.current.value).trim()
        if (code === '') {
            setError('Please enter a coupon code')
            setLoader(false)
            return
        }

        try {
            await applyCouponCart(code)
            await afterCouponApply()
        } catch (e) {
            setError(getErrorMessage(e))
        } finally {
            setLoader(false)
            setError('')
        }
    }

    const listCoupons = coupons.map((coupon) => {
        return (
            <span
                key={coupon.code}
                className="inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-700">
                {coupon.code}
                <button
                    type="button"
                    onClick={() => removeCoupon(coupon.code)}
                    className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-orange-400 hover:bg-orange-200 hover:text-orange-500 focus:outline-none focus:bg-orange-500 focus:text-white">
                    <span className="sr-only">Remove</span>
                    <XIcon className="h-2 w-2" />
                </button>
            </span>
        )
    })

    return (
        <div className="border-b w-full mb-6 pb-6 border-gray-200 relative">
            {loader && <Loader />}
            {loader && <InlineLoader> Validating Your Code... </InlineLoader>}
            {coupons.length < 1 && (
                <CouponForm {...{ counponText, applyCoupon }} />
            )}
            <div>
                {coupons.length > 0 && (
                    <div>
                        <span>Coupon Applied</span> {listCoupons}
                    </div>
                )}
            </div>
            {error && <ErrorAlert error={error} />}
        </div>
    )
}

export default Coupon
